<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="discuss-message" v-bind:id="'messagecontainer' + messageid" v-bind:key="'messagecontainer' + messageid">
    <div class="col-12">
      <div class="row p-0">
        <div v-if="viewmode != 'flat' || username != currentuser" class="mr-3" v-bind:class="getGrid('col-1')" style="width: 40px;float:left" v-bind:style="getAlignment(username)">
          <user-detail-button v-bind:username="username" v-bind:url="getUserIcon(username)"></user-detail-button>

        </div>
        <div v-bind:class="getClassAlignment(username,'col-10')" @click="clicked = !clicked" @mouseover="hover = true"
             @mouseleave="hover = false">
          <div class="font-size-sm">{{userabbreviation}} {{dateandtime}}</div>
          <div class="" style="position:relative" v-bind:class="getMessageClass(username)" v-bind:style="getMessageStyle(username, issinglemessage)">
            <div class="row px-0 mx-0 skin light-bg">
              <div v-html="labelforupdate" v-bind:id="'messagecontent' + messageid" v-bind:key="'messagecontent' + messageid" class="emojionearealocked col-11 px-2 pr-3 m-0 my-2" style="position:relative; text-align:left">
              </div>
              <div class="col-1 px-0 mx-0" v-bind:class="{'dropup':islast == true}">
                <a href="#" class="list-icons-item caret-0 font-weight-bold" v-bind:class="{'dropup':islast == true}" data-toggle="dropdown" data-boundary="viewport" style="position:absolute;top:0;right:5px;padding-left:5px;min-width:5px;z-index:100000">
                  <i class="" v-bind:class="{'icon-menu':hover == true || clicked == true,'dropup':islast == true}" style="width:18px"></i>
                  <div v-show="hover == false && clicked == false" class="" style="width:18px;display:none;">&nbsp;</div>
                </a>
                <div class="skinnedmenu dropdown-menu viewportfix" v-bind:class="{'dropup':islast == true}">
                  <div v-on:click="toggleReply(messageid);" class="dropdown-item">{{$t('reply')}}</div>
                  <div v-if="isadmin == true" v-on:click="deleteMessage();" class="dropdown-item">{{$t('delete')}}</div>
                  <div v-if="isadmin == true" v-on:click="toggleUpdate(messageid);" class="dropdown-item">{{$t('update')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="viewmode == 'flat' && username == currentuser" class="mr-2" v-bind:class="getGrid('col-1')" style="width: 40px;float:left;padding-top:15px;" v-bind:style="getAlignment(username)">

          <user-detail-button v-bind:username="username" v-bind:url="getUserIcon(username)"></user-detail-button>

        </div>
      </div>

      <form>
        <div v-show="state.isUpdateVisible == true">
          <div class="row mt-1">
            <div class="col-12 px-2 chat-textbox" style="min-width:200px">
              <textarea class="form-control messageinput" v-model="updateMessage" v-bind:placeholder="$t('reply_to_message')" v-bind:id="'messageinput' + messageid"></textarea>
              <a class="btn btn-link mt-1 ml-2" @click="cancelupdate()" style="color:inherit">{{$t('cancel')}}</a>
              <button type="button" class="btn skin primary-button mt-1 ml-2" style="background-color:rgb(217, 231, 192)" @click="update()">{{$t('update')}}</button>
            </div>
          </div>
        </div>
        <div v-show="state.isReplyVisible == true">
          <div class="row mt-1">
            <div class="col-12 px-2" style="min-width:200px">
              <div class="row">
                <div class="col-12 chat-textbox">
                  <textarea class="skin form-control messageinput" v-model="replyMessage" v-bind:placeholder="$t('reply_to_message')" v-bind:id="'messagereplyinput' + messageid"></textarea>
                </div>
                <div class="col-12">
                  <button type="button" class="btn mt-1 ml-2" @click="cancelreply()">{{$t('cancel')}}</button>
                  <button type="button" class="btn skin primary-button mt-1 ml-2" style="background-color:rgb(217, 231, 192)" @click="reply()">{{$t('post')}}</button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </form>

    </div>
    <discuss-recursive-message v-bind:forumname="forumname" v-bind:procedure="procedure" v-bind:style="getStyle()" v-bind:mode="viewmode" v-for="node in nodes" :isadmin="node.isadmin" :islast="node.isLast" :nodes="node.nodes" v-bind:issinglemessage="node.issinglemessage" v-bind:unformattedlabel="node.unformattedlabel" :label="node.label" :username="node.UserName" :messageid="node.messageid" :threadid="node.threadid" :dateandtime="node.dateandtime" :userabbreviation="node.userabbreviation" v-on:updatedthread="updatedthreadHandler"></discuss-recursive-message>
  </div>
</template>
<script>

  let replyMessage = "";
  let updateMessage = "";
  var currentuser = "";
  var hover = false;
  var clicked = false;

  export default {
    props: {
      nodes: {
        required: false,
        type: Array,
        default: null
      },
      username: {
        required: false,
        type: String,
        default: null
      },
      label: {
        required: false,
        type: String,
        default: null
      },

      unformattedlabel: {
        required: false,
        type: String,
        default: null
      },
      messageid: {
        required: false,
        type: Number,
        default: null
      },
      threadid: {
        required: false,
        type: Number,
        default: null
      },
      dateandtime: {
        required: false,
        type: String,
        default: null
      },
      userabbreviation: {
        required: false,
        type: String,
        default: null
      },
      uid: {
        required: false,
        type: String,
        default: null
      },
      mode: {
        required: false,
        type: String,
        default: "tree"
      },
      value: {
        required: false,
        type: Array,
        default: null
      },
      isadmin: {
        required: false,
        type: Boolean,
        default: false
      },
      issinglemessage: {
        required: false,
        type: Boolean,
        default: false
      },

      islast: {
        required: false,
        type: Boolean,
        default: false
      },
      forumname: {
        required: false,
        type: String,
        default: null
      },

    },
    name: 'discuss-recursive-message',
    components: {
    },
    data() {
      return {
        currentuser,
        viewmode: this.mode,
        state: {
          isReplyVisible: false,
          isUpdateVisible: false,
        },
        updateMessage: this.unformattedlabel,
        replyMessage,
        hover,
        clicked,
        textarea: null,
      }
    },
    methods: {
      getUserIcon(username) {
        return apiUrl + "/api/Memberships/v1/User/SquareImage?username=" + username;
      },
      cancelreply() {
        this.state.isReplyVisible = false;
      },
      cancelupdate() {
        this.state.isUpdateVisible = false;
      },
      getGrid(col) {
        if (this.viewmode == "flat") {
          return col;
        }
        return null;
      },
      getAlignment(messageusername) {
        if (this.viewmode == "flat") {
          if (messageusername == this.currentuser) {
            return "float:right !important;"
          }
          else
            return "float:left !important;"
        }
        return null;
      },
      getClassAlignment(messageusername, grid) {
        var ret = this.getGrid(grid);
        if (this.viewmode == "flat") {
          if (messageusername == this.currentuser) {
            ret += " text-right"
          }
          else
            ret += " text-left"
        }
        return ret;
      },
      getMessageClass(messageusername) {
        if (messageusername == this.currentuser && this.viewmode == "flat") {
          var ret = "skin light-bg media-chat-item-right container-fluid p-0"
          return ret;
        }
        else if (messageusername == this.currentuser) {
          var ret = "skin light-bg media-chat-item-left container-fluid p-0"
          return ret;
        }
        else {
          ret = "skin dark-bg media-chat-item-left container-fluid p-0"
          return ret;
        }
      },
      getMessageStyle(messageusername, issinglemessage) {
        if (messageusername == this.currentuser) {
          var ret = ""
          if (issinglemessage)
            ret = ""
          if (this.viewmode == "flat") {
            ret += "float:right"
          }
          return ret;
        }
        return null;
      },
      getStyle() {
        if (this.viewmode == "flat")
          return "padding-top:10px;padding-bottom:10px;";
        return "padding:30px; padding-left:20px;padding-bottom:0px;";
      },
      getPadding(padding) {
        if (typeof padding != "undefined");
        return style;
        return "";
      },
      attachEventWithEditor(id) {
        const parentEl = document.getElementById(id);//this.$el.querySelector('.discuss-message');
        const elements = parentEl.querySelectorAll('.emojionearea-editor');

        // Attach event listeners
        elements.forEach(element => {
          //element.style.color = 'green';
          element.addEventListener('input', this.$parent.handleInputChange);
          this.$forceUpdate();
        });

      },
      toggleReply(messageid) {
        var id = 'messagecontainer' + messageid
        this.state.isUpdateVisible = false;
        this.state.isReplyVisible = !this.state.isReplyVisible;
        this.attachEventWithEditor(id);
      },
      toggleUpdate(messageid) { 
        //var parentDiv = $('#messageinput' + messageid).parent();
        //var element = $(parentDiv).find('.emojionearea-editor');
        //$(element).html($('#messageinput' + messageid).val());

        var id = 'messagecontainer' + messageid
        this.state.isReplyVisible = false;
        this.state.isUpdateVisible = !this.state.isUpdateVisible;
        this.attachEventWithEditor(id);
      },

      async reply() {
        var parentDiv = $('#messagereplyinput' + this.messageid).parent();
        var element = $(parentDiv).find('.emojionearea-editor');
        $('#messagereplyinput' + this.messageid).val($(element).html())
        var m = $('#messagereplyinput' + this.messageid).val();
        var request = { AddReplyThreadId: this.threadid, message: m, AddReplyMessageId: this.messageid, forumname: this.forumname };
        try {
          var response = await this.$http.post(
            '/api/Threads/v1/Reply',
            request
          );

          this.$emit('updatedthread', this.threadid);

          this.replyMessage = "";
          this.state.isUpdateVisible = false;
          this.state.isReplyVisible = false;
          this.$parent.loadTags();

        } catch (err) {
          alert(err);
        }
      },      
      async update() {
        // Using jQuery to get the parent element
        var parentDiv = $('#messageinput' + this.messageid).parent();
        var element = $(parentDiv).find('.emojionearea-editor');
        $('#messageinput' + this.messageid).val($(element).html())
        //alert($('#messageinput' + this.messageid).val());
        var m = $('#messageinput' + this.messageid).val();
        var request = { threadid: this.threadid, messageId: this.messageid, message: m };

        try {

          var response = await this.$http.post(
            '/api/Forum/UpdateMessage',
            request
          );

          this.label = this.emojiString(this.updateMessage);
          this.$emit('updatedthread', this.threadid);
          this.state.isReplyVisible = false;
          this.state.isUpdateVisible = false;
          this.$parent.loadTags();
        } catch (err) {
          alert(err);
        }
      },
      async deleteMessage() {
        try {

          var response = await this.$http.post(
            '/api/Forum/DeleteMessage',
            { threadid: this.threadid, id: this.messageid }
          );
          this.$emit('updatedthread', this.threadid);
          this.$root.$emit("procedure_chat_message_deleted", this.threadid);

        } catch (err) {
          alert(err);
        }
      },
      emojiString(str) {
        var keys = '';

        var animations = '\\abe|access|angel|airplane|alarm_clock|alien|anger|angry|astonished|bandit|beer|bell|bertlett|bhangra|bike|bing|birthday|blackwidow|blush|bollylove|bomb|boom|bow|bowled|brb|bug|broken_heart|bulb|cake|call|camera|canyoutalk|car|cat|captain|chai|champagne|chappal|cheese|christmas_tree|clap|clapper|confetti_ball|clock|coffee|crown|cry|crying_cat_face|computer|computerrage|confidential|cool|cwl|coutinho10|dance|devil|dhakkan|discodancer|disgust|diya|dizzy_face|dog|doh|donkey|donttalktome|drink|drunk|dull|eg|emo|envy|evilgrin|excel|eyes|facepalm|finger|fear|fingerscrossed|fistbump|fireworks|fish|fishing_pole_and_fish|fist|flushed|flower|frog|frowning|footballfail|fubar|ghost|gift|giggle|golmaal|goodluck|gottorun|grimacing|grin|grinning|hamburger|handshake|handsinair|hanukkah|happy|headbang|headphones|heart|heart_eyes|heartbeat|heartpulse|hearts|heidi|henderson14|hi|highfive|holdon|holidayspirit|hollest|helicopter|hug|horse|hushed|hungover|idea|inlove|internetexplorer|island|joy|kaanpakadna|kangaroo|key|kiss|kissing_face|klopp|kya|laugh|laughing|learn|letsmeet|lips|lipssealed|listening|man|mlt|mmm|microsoft|mail|makeup|monkey|mooning|movie|muscle|music|muscleman|movember|nahi|nazar|neil|nerdy|nickfury|ninja|no|nod|naturescall|notes|ok|oliver|onedrive|onenote|ontheloo|outlook|oye|party|penguin|pig|poop|phone|pizza|plane|poke|polarbear|poolparty|powerpoint|praying|priidu|prohibed|promise|publisher|puke|pullshot|pumpkin|punch|rain|rainbow|raindeer|rabbit|rocket|roller_coaster|rock|runner|rofl|sad|sadness|santa|santamooning|sarcastic|shake|sharepoint|sheep|shielddeflect|shivering|shopping|skipping|skull|skype|skypebiz|slap|sleepy|smile|smirk|smoke|snowangel|speechless|star|stop|sturridge15|surprised|snail|suryannamaskar|swear|sweat|sunny|sunrise|talk|talktothehand|tandoorichicken|taur|think|time|tired_face|tmi|toivo|tongueout|tubelight|tumbleweed|turkey|umbrella|vampire|wait|waiting|wfh|whatsgoingon|whistle|woman|wink|win10|whew|wasntme|wonder|word|worry|xmastree|xbox|wtf|victory|violin|volcano|yawn|yes|yoga|zany|zombie|zipper';
        //var animations = '\\airplane|alarm_clock|alien|anger|angry|astonished|birthday|blush|bomb|boom|bug|bulb|camera|christmas_tree|clap|clapper|confetti_ball|crown|cry|crying_cat_face|disappointed|dizzy_face|eyes|fireworks|fish|fishing_pole_and_fish|fist|flushed|frog|frowning|ghost|grimacing|grin|grinning|hamburger|heart|heart_eyes|heartbeat|heartpulse|hearts|helicopter|horse|hushed|kiss|kissing_face|laughing|lips|notes|penguin|pig|poop|rabbit|rocket|roller_coaster|runner|sunny|sunrise|tired_face|volcano|';
        var animationRegex = new RegExp(':(' + animations + '):', 'g');
        var regex = new RegExp(':(' + keys + '):', 'g');
        // Row breaks should be visible in html
        str = str.replace(/(\r\n|\r|\n)/g, '<br>');
        var tmpStr = str.replace(/:\s*/g, '');
        if (animations.includes(tmpStr)) {
          // Animation, make it bigger
          return str.replace(animationRegex, this.emojiReplaceAnimationBig);
        }
        else if (typeof (keys.includes) != 'undefined' && keys.includes(tmpStr)) {
          // Just a single icon, make it bigger
          return str.replace(regex, this.emojiReplaceBig);
        }
        else
          return str.replace(regex, this.emojiReplace);
      },
      emojiReplaceAnimationBig() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/animations';
        var extension = '.gif';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplaceBig() {
        var key = arguments[1];
        //var url = '/images/emoji/static';
        var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="60" height="60" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      emojiReplace() {
        var key = arguments[1];
        //var url = 'https://github.com/SCRAPTURE/jquery-emoji/raw/master/images/emojis';
        var url = '/images/emoji/static';
        var extension = '.png';
        var src = url + '/' + key + extension;
        return '<img class="emoji" width="20" height="20" align="absmiddle" src="' + src + '" alt="' + key + '" title="' + key + '" />';
      },
      updatedthreadHandler(id) {
        this.$emit('updatedthread', id);
      }
    },
    computed: {
      labelforupdate: {
        get() {
          return this.label;
        }
      },
      thedate: {
        get() {
          return (new Date()).getSeconds();
        }
      }
    },
    created: function () {
      if (this.$store != null && typeof (this.$store) != 'undefined')
        this.currentuser = this.$store.getUsername();
    },
    watch: {
      label: function (newVal, oldVal) {
        this.label = newVal;
        this.cancelreply();
        this.cancelupdate();
        this.$forceUpdate();
      },
      nodes: function (newVal, oldVal) {
        Vue.set(this, "nodes", newVal)
        this.cancelreply();
        this.cancelupdate();
        this.$forceUpdate();
      },

    },
    mounted() {
      var currentContext = this;
      var el= $('#messageinput' + this.messageid).emojioneArea(
        {
          tones: true,
        });
      el[0].emojioneArea.on("emojibtn.click", function (button, event) {
        currentContext.textarea.innerHTML = el[0].emojioneArea.getText();
        el[0].emojioneArea.setFocus();
      });
      el[0].emojioneArea.on("focus", function (editor, event) {              
        var parentDiv = $(el[0]).parent();
        var element = $(parentDiv).find('.emojionearea-editor');
        currentContext.textarea = element;
        $(element).html(el[0].emojioneArea.getText());
      });

      var el1 = $('#messagereplyinput' + this.messageid).emojioneArea(
        {
          tones: true,
        });
      el1[0].emojioneArea.on("emojibtn.click", function (button, event) {
        currentContext.textarea.innerHTML = el1[0].emojioneArea.getText();
        el1[0].emojioneArea.setFocus();
      });
      el1[0].emojioneArea.on("focus", function (editor, event) {      
        var parentDiv = $(el1[0]).parent();
        var element = $(parentDiv).find('.emojionearea-editor');
        currentContext.textarea = element;
        $(element).html(el1[0].emojioneArea.getText());
      });

    },
  }
</script>

<style>
  .emoji {
    vertical-align: top;
  }
</style>

<style scoped>
  .emoji {
    vertical-align: top;
  }


  .discuss-message {
  }

  .media-chat-item {
    min-width: 150px;
  }

  .media-chat-item-right, .media-chat-item-left, .media-chat-item-right .skin.light-bg, .media-chat-item-left .skin.light-bg {
    border-radius: 8px;
  }

  .media-chat-item-right {
    min-width: 150px;
    min-width: 150px;
    width: auto;
    display: inline-block;
    color: #333;
  }

    .media-chat-item-right::before {
      content: '';
      left: -5px;
      top: 1rem;
      position: absolute;
      margin-left: 0;
      border-top: 5px solid transparent;
      border-right: 5px solid;
      border-right-color: inherit;
      border-bottom: 5px solid transparent;
      left: auto;
      right: -5px;
      border-right: 0;
      border-left: 5px solid;
    }


  .media-chat-item-left {
    min-width: 150px;
    width: auto;
    display: inline-block;
    color: #333;
  }

    .media-chat-item-left::before {
      content: '';
      left: -5px;
      top: 1rem;
      position: absolute;
      margin-left: 0;
      border-top: 5px solid transparent;
      border-right: 5px solid;
      border-bottom: 5px solid transparent;
    }
</style>



// WEBPACK FOOTER //
// src/components/discuss/discuss-recursive-message.vue